import React from 'react';
import { Typography, MenuItem, Divider } from '@mui/material';
import { isProTeam } from '../../../../utils';
import { useUser } from '../../../../hooks/useUser';
import FormRow from './row';
import FieldInput from './FieldInput';
import { FieldSelect } from './FieldSelect';
import { agencyTypeList, statesList } from './constants';
import { IconDollar } from '../../../../utils/icons';
import FieldCheckbox from './FieldCheckbox';

export default function FormContactInfo() {
  const { role } = useUser();

  return (
    <>
      <FormRow count={2}>
        <FieldSelect
          name="agencyType"
          label="Agency Type"
          options={agencyTypeList}
        />
        <FieldInput name="agencyName" label="Agency Name" />
      </FormRow>

      <FormRow count={2}>
        <FieldInput
          name="agencyEmail"
          label="Agency Email"
          placeholder="agency@example.com"
        />
        <FieldInput
          name="agencyPhoneNumber"
          label="Agency Phone"
          placeholder="(123)456-7890"
        />
      </FormRow>

      <Divider />

      <FormRow count={2}>
        <FieldInput
          name="phoneNumber"
          label="Phone Number"
          placeholder="(123)456-7890"
        />
        <FieldInput name="website" label="Website" placeholder="example.com" />
      </FormRow>

      <Divider />

      <FormRow>
        <FieldInput name="address1" label="Address 1" />
      </FormRow>

      <FormRow>
        <FieldInput name="address2" label="Address 2" />
      </FormRow>

      <FormRow count={3}>
        <FieldInput name="city" label="City" placeholder="City" />
        <FieldSelect name="state" objectOptions={statesList} />
        <FieldInput name="zipcode" label="Zip Code" placeholder="Zip Code" />
      </FormRow>

      {isProTeam(role) && (
        <>
          <Divider />

          <Typography
            className="text-text-1 text-sm"
            fontFamily="CircularStdBlack"
          >
            Pay rate production
          </Typography>

          <FormRow count={3}>
            <FieldInput
              name="payRateProduction-fullDay"
              label="Full Day"
              postIcon={<IconDollar />}
            />
            <FieldInput
              name="payRateProduction-halfDay"
              label="Half Day"
              postIcon={<IconDollar />}
            />
            <FieldInput
              name="payRate-productTesting"
              label="Product Testing"
              postIcon={<IconDollar />}
            />
          </FormRow>

          <Typography
            className="text-text-1 text-sm"
            fontFamily="CircularStdBlack"
          >
            Pay rate social media post
          </Typography>

          <FormRow count={3}>
            <FieldInput
              name="payRateSmp-instagram"
              label="Instagram"
              postIcon={<IconDollar />}
            />
            <FieldInput
              name="payRateSmp-twitter"
              label="Twitter"
              postIcon={<IconDollar />}
            />
            <FieldInput
              name="payRateSmp-tiktok"
              label="TikTok"
              postIcon={<IconDollar />}
            />
          </FormRow>

          <Divider />

          <FieldCheckbox
            name="msaAgreementSigned"
            text="MSA agreement signed"
          />
        </>
      )}
    </>
  );
}
